export function timeline() {
    const globalWindow = window;
    const $tl = $(".timeline");
    const $target = $(".timeline .event");
    const eventsLength = $target.length;
    let screenFactor = 0.6;

    let addHeight = globalWindow.innerHeight * screenFactor;

    let tlEvents = [];
    let $tlWatcher = undefined;
    let scrolled = globalWindow.scrollY || globalWindow.pageYOffset;
    let tlWatcherPos = 0;
    let startAnimationPos = 0;
    let endAnimationPos = 0;

    function grabData() {
        tlEvents = [];
        $tlWatcher = $tl.find(".timeline-watcher");
        addHeight = globalWindow.innerHeight * screenFactor;
        tlWatcherPos = $tlWatcher.offset().top;
        startAnimationPos = tlWatcherPos - addHeight;
        
        [...$target].forEach(item => {
            let elemProps = item.getBoundingClientRect();
            tlEvents.push({
                top: Math.floor(elemProps.top + scrolled)
            });
        });

        endAnimationPos = tlEvents[eventsLength-1].top - addHeight + 15;
        if (scrolled < endAnimationPos) {
            $tlWatcher.css("height", `${ scrolled - startAnimationPos}px`);
        }

        if (scrolled > endAnimationPos) {
            $tlWatcher.css("height", `${ tlEvents[eventsLength-1].top - tlEvents[0].top}px`);
        }
    }

    function animate() {
        scrolled = globalWindow.scrollY || globalWindow.pageYOffset;

        if (tlWatcherPos < globalWindow.pageYOffset + addHeight) {
            $tlWatcher.addClass("active");
            if (scrolled < endAnimationPos) {
                $tlWatcher.css("height", `${ scrolled - startAnimationPos}px`);
            }
            if (scrolled > endAnimationPos) {
                $tlWatcher.css("height", `${ tlEvents[eventsLength-1].top - tlEvents[0].top}px`);
            }
        } else {
            $tlWatcher.removeClass("active");
            $tlWatcher.css("height", 0);
        }

        [...$target].forEach( (item, index) => {
            let $item = $(item);

            if (tlEvents[index].top < globalWindow.pageYOffset + addHeight) {
                $item.addClass("current");
            } else {
                $item.removeClass("current");
            }
        });
    }

    globalWindow.addEventListener("load", () => {
        grabData();
        animate();
    });
    globalWindow.addEventListener("scroll", () => {
        animate();
    });
    globalWindow.addEventListener("resize", () => {
        grabData();
        animate();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/timeline.js